import instance from "@/services/apiService";
import apiUrls from "@/services/apiUrls";
import store from "@/store";

const getServices = () =>
  instance.get(`${apiUrls.SERVICES}?branch=${store.getters.selectedBranch.id}&sort=name`);

const getPopularServices = () =>
  instance.get(
    `${apiUrls.POPULAR_SERVICES}?limit=5&branch=${store.getters.selectedBranch.id}`
  );

const getPromotionServices = () =>
  instance.get(
    `${apiUrls.PROMOTION_SERVICES}?branch=${store.getters.selectedBranch.id}`
  );

const getEmployeeTimeslot = (serviceId, date, branchId) =>
  instance.get(
    `${apiUrls.EMPLOYEE_TIMESLOT}?serviceWrapperId=${serviceId}&selectDate=${date}&branchId=${branchId}`
  );

/**
 * Get the specific promotion service valid booking date range for a specific branch
 */
const getPromotionServiceBranchBookingDateRange = (branchId, productId, promotionId) =>
  instance.get(
    `${apiUrls.BRANCH_BOOKING_DATE_RANGE}?branchId=${branchId}&productId=${productId}&promotionId=${promotionId}`
  );

export {
  getServices,
  getPopularServices,
  getPromotionServices,
  getEmployeeTimeslot,
  getPromotionServiceBranchBookingDateRange,
};
